export function ListItem({ number, children }) {
  return (
    <li className="flex items-start gap-3">
      <span className="flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-dodger-blue-500 text-base font-bold leading-6 text-white">
        <span className="mt-px text-white">{number}</span>
      </span>
      <span className="text-base font-normal tracking-[-0.008em] leading-6 text-black-pearl-500">{children}</span>
    </li>
  );
}
